
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify/types'
import { OperationHistory } from '@/types'
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading'
import UsedDyestuffs from '@/components/UsedDyestuffs.vue'

@Component({
  components: {
    InfiniteLoading,
    UsedDyestuffs,
  },
})
export default class OldReservationOperationHistoryTable extends Vue {
  @Prop({ type: String, default: null }) readonly account!: string | null
  @Prop({ type: String, default: '450px' }) readonly height!: string | number
  @Prop({ type: Boolean, default: false }) readonly hideStaffs!: boolean

  loading = false
  items: OperationHistory[] = []
  next: null | string = null

  get headers() {
    let rval: DataTableHeader[] = [
      {
        text: '施術日',
        value: 'date',
        width: 95,
      },
      {
        text: 'お店',
        value: 'shopName',
        width: 90,
      },
      {
        text: 'お客様番号',
        value: 'account',
        class: ['text-no-wrap'],
        width: 80,
      },

      {
        text: '姓',
        value: 'familyNameKana',
        width: 80,
      },
      {
        text: '名',
        value: 'firstNameKana',
        width: 80,
      },
      {
        text: 'メニュー',
        value: 'menuName',
        width: 120,
      },
      {
        text: 'メモ',
        value: 'memo',
        width: 300,
      },
    ]
    rval.forEach((x) => {
      x.sortable = false
    })
    return rval
  }

  @Watch('account', { immediate: true })
  onAccountChanged() {
    this.items = []
    this.next = null
  }

  async fetchData($state: StateChanger) {
    if (!this.account) {
      $state.complete()
      return
    }
    try {
      this.loading = true
      let { results, next } = await (this.next
        ? this.$api.http.get(this.next)
        : this.$api.oldOperationHistories().list({ account: this.account }))
      this.items = this.items.concat(results)
      this.$emit('items', this.items)
      this.next = next
      if (this.items.length) $state.loaded()
      if (!this.next) $state.complete()
    } catch (err) {
      console.error(err)
      $state.error()
    }
    this.loading = false
  }

  rowColor(item: OperationHistory) {
    if (!item.isActive) {
      return 'grey'
    }
  }
}
